import gql from 'graphql-tag';
import * as React from 'react';
import { ChildProps, compose, graphql } from 'react-apollo';

export const GetFullVariantsQuery = gql`
  query($ids: [String!]) {
    variants(where: { id_in: $ids }) {
      id
      ean
      sku
      price
      recommendedPrice
      definition
      productId
      product {
        id
        title
        name
        price
        recommendedPrice
        description
        status
        sku
        tags
        images {
          id
          file
          createdAt
          priority
          values {
            id
          }
        }
        prices {
          id
          productId
          productVariantId
          currencyId
          priceWithout
        }
        availabilityId
        availability {
          id
          title
        }
        hideForCountry
        visibleForCustomerGroup
      }
      attributeValues {
        id
        value
        title
        attribute {
          id
          isVisual
        }
      }
    }
    productTags {
      id
      name
      title
      slug
      color
      active
    }
  }
`;

interface IInputProps {
  children?: any;
  ids?: Array<string>;
  returnEmpty?: boolean;
}

interface Response {
  data: any;
}

class VariantsQuery extends React.Component<ChildProps<IInputProps, Response>, {}> {

  public render() {
    if (this.props.returnEmpty) {
      const fullVariants = {
        loading: false,
        variants: []
      };

      return this.props.children({
        fullVariants
      });
    }
    const { fullVariants, productTags }: any = this.props;
    return this.props.children({
      fullVariants, productTags
    });
  }
}

// # variants(where: { attributeValues_some: { id_in: $filterValues } }) {

export default compose(
  graphql<IInputProps, Response>(GetFullVariantsQuery, {
    name: 'fullVariants',
    options: props => ({
      variables: {
        ids: props.ids
      }
    })
  })
)(VariantsQuery);



// WEBPACK FOOTER //
// ./src/components/Query/Products/GetFullVariants.tsx